import { ImportModule } from "app/helpers/importsHelper";
import { HOC } from "app/helpers/routerHocHelper";
import { ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import ENV from "config";
import { Redirect, Route, Switch } from "react-router-dom";
import DesktopRouteHelper from "../../helpers/DesktopRouteHelper/DesktopRouteHelper";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import DesktopRouterRedirects from "./components/DesktopRouterRedirects/DesktopRouterRedirects";
type Props = {
  location: any;
};

const DesktopRouter: React.FC<Props> = ({ location }) => {
  return (
    <Switch>
      {/* here? */}
      <Route
        path="/:url*"
        exact
        strict
        render={({ location }) =>
          location.pathname.endsWith("/") ? null : (
            <Redirect to={`${location.pathname}/`} />
          )
        }
      />
      {!SessionHelper.isAuthenticated() && ENV.CSS_THEME === "DEFAULT" && (
        <Route exact path={ROUTES.root} component={ImportModule.PublicScreen} />
      )}
      {!SessionHelper.isAuthenticated() && (
        <Route path={ROUTES.login} component={ImportModule.AuthScreen} />
      )}
      {!SessionHelper.isAuthenticated() && (
        <Route
          path={ROUTES.register}
          component={ImportModule.RedirectToLogin}
        />
      )}
      {SessionHelper.isAuthenticated() && (
        <PrivateRoute
          path={ROUTES.promoCategory}
          component={HOC.PromoCategory}
        />
      )}
      {/* hack for routing used in ManageFunding and DesktopReportsScreen */}
      {SessionHelper.isAuthenticated() && (
        <PrivateRoute
          path={ROUTES.reports}
          component={ImportModule.ReportsScreen}
        />
      )}
      {SessionHelper.isAuthenticated() && (
        <PrivateRoute
          path={ROUTES.manageFunding}
          component={HOC.ManageFundingScreenDesktop}
        />
      )}{" "}
      {/* load remaining routes */}
      {SessionHelper.isAuthenticated() &&
        DesktopRouteHelper.map((route, index) => (
          <PrivateRoute
            exact
            key={index}
            path={route.path}
            component={route.component}
          />
        ))}
      {/* redirects */}
      <DesktopRouterRedirects />
    </Switch>
  );
};

export default DesktopRouter;
